/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { FaChevronRight } from "react-icons/fa6";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import SearchFilterSection from "../../components/common/SearchFilterSection";
import PendingRegistrationList from "../../components/tables/PendingRegistrationList";
import { getUniqueValues } from "../../libs/UnauthorisedPage";
import { getApiCaller } from "../../libs/apiCaller";

const PendingRegistration = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [showPendingRegistrationList, setShowPendingRegistrationList] =
    useState([]);
  const [filteredPendingRegistrationList, setFilteredPendingRegistrationList] =
    useState([]);
  const [cities, setCities] = useState([]);
  const [states, setStates] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedState, setSelectedState] = useState("");
  const [selectedCity, setSelectedCity] = useState("");

  useEffect(() => {
    getPendingRegistrationList();
  }, []);

  const getPendingRegistrationList = async () => {
    setIsLoading(true);
    const endPoint = `providers_list?type=pending`;
    try {
      const response = await getApiCaller(endPoint);
      if (response?.data?.response_code === 200) {
        setShowPendingRegistrationList(response?.data?.response_data);
        setFilteredPendingRegistrationList(response.data.response_data);
        setStates(
          getUniqueValues(response?.data?.response_data, "billing_state")
        );
      }
    } catch (error) {
      toast.error("Failed to fetch data.");
    }
    setIsLoading(false);
  };

  useEffect(() => {
    applyFilters();
  }, [searchTerm, selectedState, selectedCity]);

  const applyFilters = () => {
    let filteredData = showPendingRegistrationList;

    if (searchTerm) {
      filteredData = filteredData.filter((consumer) => {
        const fullName = `${consumer?.first_name || ""} ${
          consumer.last_name || ""
        }`?.toLowerCase();
        return fullName?.includes(searchTerm?.toLowerCase());
      });
    }

    if (selectedState) {
      filteredData = filteredData.filter(
        (consumer) => consumer.billing_state === selectedState
      );
      setCities(getUniqueValues(filteredData, "billing_city"));
    } else {
      setCities(getUniqueValues(showPendingRegistrationList, "billing_city"));
    }

    if (selectedCity) {
      filteredData = filteredData.filter(
        (consumer) => consumer.billing_city === selectedCity
      );
    }

    setFilteredPendingRegistrationList(filteredData);
  };

  const clearFilters = () => {
    setSearchTerm("");
    setSelectedState("");
    setSelectedCity("");
    setFilteredPendingRegistrationList(showPendingRegistrationList);
    setCities(getUniqueValues(showPendingRegistrationList, "billing_city"));
  };

  return (
    <>
      <div className="px-4 md:px-10">
        <div className="flex items-center border border-1 gap-2 px-4 py-3 rounded-t-2xl text-xl mt-4 bg-white">
          <Link to={"/provider"} className="text-[#284184] text-xl">
            Approved Providers
          </Link>
          <FaChevronRight className="text-md" />
          <p className="text-[#284184] font-bold">Pending Registration</p>
        </div>
        <div className="border border-t-0 px-4 py-3 rounded-b-2xl text-xl bg-white">
          <SearchFilterSection
            searchTextPlaceholder={"Search Provider Name"}
            searchTerm={searchTerm}
            selectedCity={selectedCity}
            selectedState={selectedState}
            cities={cities}
            states={states}
            clearFilters={clearFilters}
            setSearchTerm={setSearchTerm}
            setSelectedCity={setSelectedCity}
            setSelectedState={setSelectedState}
          />

          <PendingRegistrationList
            isLoading={isLoading}
            showPendingRegistrationList={filteredPendingRegistrationList}
          />
        </div>
      </div>
    </>
  );
};

export default PendingRegistration;
